<template>
    <div class="two-house-area pt-100 pb-70" id="info">
        <div class="container">
            <div class="row">
                <div class="col-sm-6 col-lg-4">
                    <div class="house-item">
                        <div class="house-icon">
                            <i class='bx bx-shopping-bag'></i>
                        </div>
                        <h3>¿Porqué elegirnos?</h3>
                        <p>Elegir Plotix es elegir experiencia, rapidez y confianza.
                        Ofrecemos servicios técnicos especializados, mantenimiento preventivo y venta de insumos de primera calidad.
                        Con nosotros, tus equipos de impresión estarán siempre listos para producir al máximo nivel.</p>
                        <a href="tel:+34 623 61 51 28">
                            Comenzar 
                            <i class='bx bx-right-arrow-alt'></i>
                        </a>
                    </div>
                </div>
                <div class="col-sm-6 col-lg-4">
                    <div class="house-item">
                        <div class="house-icon">
                            <i class='bx bx-dollar-circle'></i>
                        </div>
                        <h3>Inversión Inteligente</h3>
                        <p>Invertir en el mantenimiento de tus equipos con Plotix es una decisión que reduce costes y evita paradas.
                        Nuestros contratos de servicio técnico prolongan la vida útil de tus impresoras y aseguran el mejor rendimiento a largo plazo.
                        Optimizá tus recursos con un mantenimiento planificado y soporte técnico profesional.</p>
                        <a href="tel:+34 623 61 51 28">
                            Comenzar 
                            <i class='bx bx-right-arrow-alt'></i>
                        </a>
                    </div>
                </div>
                <div class="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4">
                    <div class="house-item">
                        <div class="house-icon">
                            <i class='bx bx-globe'></i>
                        </div>
                        <h3>Nuestra Misión</h3>
                        <p>En Plotix, nuestra misión es ofrecer soluciones rápidas, confiables y de alta calidad para garantizar la continuidad y eficiencia de tus operaciones de impresión.
                        Nos enfocamos en la excelencia técnica, la atención personalizada y la mejora constante de nuestros servicios.
                        Buscamos ser el aliado estratégico de cada cliente, brindando soporte y confianza en cada paso del proceso.</p>
                        <a href="tel:+34 623 61 51 28">
                            Comenzar
                            <i class='bx bx-right-arrow-alt'></i>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Services'
}
</script>
<style scoped>
/* === SECCIÓN: TWO-HOUSE-AREA === */
.two-house-area {
  position: relative;
  padding-top: 100px;
  padding-bottom: 70px;
  color: #fff;
}

/* Cada bloque */
.house-item {
  text-align: center;
  color: #fff;
  margin-bottom: 40px;
}

/* ICONO (rombo animado centrado) */
.house-icon {
  position: relative;
  width: 90px;
  height: 90px;
  margin: 0 auto 20px; /* ← centra en todas las versiones */
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  z-index: 1;
  transition: all 0.4s ease;
}

/* Rombos decorativos (efecto original) */
.house-icon::before,
.house-icon::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fff;
  left: 0;
  top: 0;
  border-radius: 5px;
  transform: rotate(45deg);
  z-index: 0;
  transition: 0.3s ease;
}

.house-icon::after {
  opacity: 0.2;
  transform: rotate(45deg) scale(1.1);
}

.house-icon i {
  position: relative;
  font-size: 34px;
  color: #ff8a00; /* color corporativo */
  z-index: 2;
  transition: transform 0.3s ease;
}

/* Animación al pasar el ratón */
.house-item:hover .house-icon i {
  transform: scale(1.1);
}

/* ======= TEXTOS ======= */
.house-item h3 {
  font-weight: 700;
  margin-bottom: 12px;
  color: #fff;
}

.house-item p {
  text-align: justify;       /* ← Justificado */
  text-justify: inter-word;
  hyphens: auto;
  color: #ddd;
  font-size: 15px;
  line-height: 1.7;
  margin-bottom: 18px;
}

/* Enlace */
.house-item a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-weight: 600;
  color: #fff;
  transition: color 0.3s ease;
}

.house-item a:hover {
  color: #ff8a00;
}

/* === RESPONSIVE === */
@media (max-width: 991px) {
  .two-house-area {
    padding-top: 80px;
    padding-bottom: 60px;
  }

  .house-icon {
    width: 80px;
    height: 80px;
    margin-bottom: 16px;
  }

  .house-icon i {
    font-size: 30px;
  }

  .house-item h3 {
    font-size: 18px;
  }

  .house-item p {
    font-size: 14px;
  }
}

@media (max-width: 575px) {
  .two-house-area {
    padding-top: 60px;
    padding-bottom: 40px;
  }

  .house-item {
    margin-bottom: 32px;
  }

  .house-icon {
    width: 72px;
    height: 72px;
  }

  .house-icon i {
    font-size: 26px;
  }

  .house-item p {
    font-size: 14px;
    line-height: 1.6;
  }
}
</style>
